import { types, Instance } from 'mobx-state-tree';

const { model, number } = types;

export const FeatureInfoModel = model('FeatureInfoModel', {
  numberOfUsers: number,
  numberOfUsersAddOn: number,
  numberOfUsersCore: number,
  previousNumberOfUsersAddOn: number,
  previousNumberOfUsersCore: number,
  currentNumberOfUserAddOn: number,
  currentNumberOfUserCore: number,
});

export type IFeatureInfoModel = Instance<typeof FeatureInfoModel>;
